PegasusTemplate.UploadController = Ember.ObjectController.extend({
  needs: ['editing'],
  contentBinding: 'controllers.editing.content'
});
